<template>
	<div>
		<div v-if="page === 'formContactUs'" id="app-form-contact-us">
			<page-form-contact-us :dealer-id="dealerId" />
		</div>
		<div v-if="page === 'formRequestAppointment'" id="app-form-request-appointment">
			<page-form-request-appointment :dealer-id="dealerId" />
		</div>
		<div v-if="page === 'localOfficeInfo'" id="app-local-office-info">
			<page-local-office-info :dealer-id="dealerId" />
		</div>
		<div v-if="page === 'locationSearch'" id="app-location-search">
			<page-location-search :dealer-id="dealerId" 
                            :show-map="showMap"/>
		</div>
		<div v-if="page === 'nextAvailable'" id="app-next-available">
			<page-next-available :clinic-id="clinicId"
                           :dealer-id="dealerId" />
		</div>
		<div v-if="page === 'onlineScheduling'" id="app-online-scheduling">
			<page-online-scheduling
        :dealer-id="dealerId" />
		</div>
	</div>
</template>

<script>
  import {mapActions, mapMutations} from "vuex";

	import pageFormContactUs from './pages/form-contact-us.vue';
	import pageFormRequestAppointment from './pages/form-request-appointment.vue';
	import pageLocalOfficeInfo from './pages/local-office-info.vue';
	import pageLocationSearch from './pages/location-search.vue';
  import pageNextAvailable from "./pages/next-available.vue";
	import pageOnlineScheduling from './pages/online-scheduling.vue';
  import Services from "./mixins/services";
  import { isGoogleAdSession } from './google-ad-attribution';

	export default {
		name: 'App',
    mixins: [Services],
    props: {
			page: {
				type: String,
				default: null,
				required: true,
			},
			clinicUrl: {
				type: String,
				default: null
			},
			clinicId: {
				type: String,
				default: null
			},
			dealerId: {
				type: String,
				default: null,
			},
			showMap: {
				type: String,
				default: 'false'
			}
		},
		components: {
			pageFormContactUs,
			pageFormRequestAppointment,
			pageLocalOfficeInfo,
			pageLocationSearch,
			pageNextAvailable,
			pageOnlineScheduling
		},
		data() {
			return {
			};
		},
		methods: {
      ...mapActions('Globals', {setLoadedDate: 'setLoadedDate'}),
      ...mapMutations('OnlineScheduling', { setOnlineSchedulingStateValue: 'setStateValue' }),
      async setUtmSessionStorage() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('utm_source')) sessionStorage.setItem('utm_source', urlParams.get('utm_source'));
        if (urlParams.get('utm_medium')) sessionStorage.setItem('utm_medium', urlParams.get('utm_medium'));
        if (urlParams.get('utm_campaign')) sessionStorage.setItem('utm_campaign', urlParams.get('utm_campaign'));
        if (urlParams.get('utm_content')) sessionStorage.setItem('utm_content', urlParams.get('utm_content'));
        if (!sessionStorage.getItem('referrer_url') || urlParams.get('emailDebug')) sessionStorage.setItem('referrer_url', window.location.href);
        isGoogleAdSession();
      },
		},
    async created() {
      if (this.clinicUrl) {
        this.setOnlineSchedulingStateValue({ key: 'clinicUrl', value: this.clinicUrl });
      }
      await this.setUtmSessionStorage();
      await this.setLoadedDate();
    },
    async beforeMount() {
      // this.helpers().createFakeCallCenterPhoneNumber();
    }
	}
</script>
